import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";

export const useBeaconAppealContext = (
  setSessionData: (data: Record<string, string>) => void,
) => {
  const { pathname } = useLocation();

  useEffect(() => {
    const match = matchPath("/appeals/:appealId/*", pathname);
    const appealId = match?.params.appealId ?? "";
    setSessionData({ appealId });
  }, [pathname, setSessionData]);
};
